// extracted by mini-css-extract-plugin
export default {"Logo":"Logo__Logo___q0wZF","light":"Logo__light___omH7c","dark":"Logo__dark___GSfTt","small":"Logo__small___CeYrE"};